import React from 'react';

import type {
  MarketLevelCompoundMarketTemplateProps,
  MarketTemplateComponent
} from '@swf/sports/types/templates';

import TableColumn from './TableColumn';
import TableRow from './TableRow';

const Table: MarketTemplateComponent<MarketLevelCompoundMarketTemplateProps> = ({
  marketIds,
  config
}) => {
  if (!('marketDirection' in config)) return null;

  if (config.marketDirection === 'ROW') {
    return <TableRow marketIds={marketIds} {...config} />;
  }

  return <TableColumn marketIds={marketIds} {...config} />;
};

Table.marketTemplateType = 'EVENT';

export default Table;
